export default __webpack_public_path__ + "static/media/downlloadIcon.4dcac0a0.svg";